import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ICaliperMessage } from '../ecg-viewer-module/models/interfaces';

export const CALIPER_ADD: string = 'CALIPER_ADD';
export const CALIPER_REMOVE: string = 'CALIPER_REMOVE';
export const CALIPER_MODIFY: string = 'CALIPER_MODIFY';

@Injectable({
    providedIn: 'root',
})
export class CaliperMessageService {
    message = new Subject<{ message: ICaliperMessage; caliperActionType: string }>();

    sendMessage(message: ICaliperMessage, caliperActionType: string) {
        this.message.next({ message, caliperActionType });
    }
}
